import { Text } from '@auspost/postmaster-react';

export const onTimeTooltipContent = (
  <>
    <Text variant='body'>It&apos;s on track to arrive by the expected date.</Text>
    <Text variant='body'>
      This date or range takes into account any disruptions we&apos;ve added to the <strong>Journey view</strong>.
    </Text>
  </>
);

export const delayedTooltipContent = (
  <>
    <Text variant='body'>
      It&apos;s likely to arrive later than we first expected, so we&apos;ve updated the delivery date.
    </Text>
    <Text variant='body'>
      Any known disruptions will be added to the <strong>Journey view</strong>.
    </Text>
  </>
);

export const updatedTooltipContent = (
  <>
    <Text variant='body'>We&apos;ve updated the expected arrival date based on the parcel&apos;s progress.</Text>
    <Text variant='body'>
      Any known disruptions will be added to the <strong>Journey view</strong>.
    </Text>
  </>
);

export const lateTooltipContent = (
  <Text variant='body'>
    Sorry about this – we&apos;ve missed the expected arrival date. We&apos;ll update that date as soon as we know more.
  </Text>
);

export const expectedTodayTooltipContent = (
  <Text variant='body'>Your parcel is expected to arrive at the delivery address within this estimated timeframe.</Text>
);
